<script>
import options from "./NykForm.options"
export default options
</script>

<template>
  <form class="nyk-form" @submit.prevent="onSubmit">
    <div class="nyk-form-field"
      v-for="(element, index) in formElements" 
      :key="element.key" >
      <component
          v-if="isVisible(element)"
          :is="getComponentType(element)"
          v-bind="staticElementProps[element.key]"
          v-on="getElementEvents(element)"
        />
    </div>

    <nyk-alert v-if="showStatusMessage" :type="submissionSucceeded ? 'success' : 'error'">
      <div v-html="submissionSucceeded ? submitSuccessMessage : submitErrorMessage"></div>
    </nyk-alert>

    <Modal 
      v-if="showSummarizedData"
      :open="showConfirmationModal" 
      @close="cancelSubmission"
      :title="confirmationMessage"
      size="small"
      theme="white"
    >
      <template #body>
        <div class="nyk-table">
          <div class="nyk-table__container">
            <table class="nyk-table__container__table">
              <tbody class="nyk-table__container__table__body">
                <tr 
                  v-for="item in confirmationData" 
                  :key="item.label"
                  class="nyk-table__container__table__body__row"
                >
                  <td class="nyk-table__container__table__body__row__item">
                    <div>{{ item.label }}</div>
                  </td>
                  <td class="nyk-table__container__table__body__row__item">
                    <div>{{ item.value }}</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </template>
      <template #footer>
        <div class="nyk-form-confirmation__actions">
          <button 
            type="button" 
            class="nyk-button nyk-button--outline-primary" 
            @click="cancelSubmission"
          >
            {{ summaryCancellationButtonLabel }}
          </button>
          <button 
            type="button" 
            class="nyk-button nyk-button--filled-primary" 
            @click="confirmSubmission"
          >
            {{ summaryConfirmationButtonLabel }}
          </button>
        </div>
      </template>
    </Modal>
  </form>
</template>